import React from 'react'

// Redux
import { connect } from 'react-redux'
import {
  PAGE_VIEWS,
} from '../actions'
import {
  tideStationSelector,
  visitedTideStationsSelector,
  locationSearchHasFocusSelector,
} from '../reducers/uiReducer'
import {
  userLocationSelector,
} from '../reducers/userLocationReducer'

// Components
import LandingPage from './LandingPage'
import Header from './Header/Header'
import DatePicker from './DatePicker'
import DayPage from './DayPage/DayPage'
import LoadingSpinner from './LoadingSpinner'
import UserLocationMessage from './UserLocationMessage'

// Styles
import '../styles/normalize.css'
import '../styles/global.css'
import styles from './App.module.css'

// Images
import loadingAnimation from '../assets/images/loading.svg'

// Add-to-homescreen
import addToHomescreen from '../lib/add-to-homescreen'


const ADD_TO_HOMESCREEN_OPTIONS = {
  lifespan: 60,           // remove automatically after 60 seconds
  displayPace: 1440,      // minutes before the message is shown again
                          // (0: display every time, default 24 hours)
  logging: (process.env.REACT_APP_ENV === 'development'),
}





export default connect(
  (state) => {
    const tideStation = tideStationSelector(state)
    const visitedStations = visitedTideStationsSelector(state)

    const hasTideStation = !!tideStation
    const shouldShowLandingPage = (
      !hasTideStation &&
      visitedStations.length === 0 &&
      !process.env.REACT_APP_SKIP_LANDING_PAGE
    )

    const userLocation = userLocationSelector(state)

    return {
      hasTideStation,
      locationSearchHasFocus: locationSearchHasFocusSelector(state),
      shouldShowLandingPage,
      shouldShowUserLocationMessage: (
        userLocation.isFetching || (userLocation.error && !hasTideStation)
      ),
      shouldShowDayPage: hasTideStation,
    }
  }
)(App)



function App(props) {

  const {
    hasTideStation,
    locationSearchHasFocus,
    shouldShowLandingPage,
    shouldShowUserLocationMessage,
    shouldShowDayPage,
  } = props

  if (shouldShowLandingPage) {
    return <LandingPage />
  }
  else {

    // Init add-to-homescreen instructions
    addToHomescreen(ADD_TO_HOMESCREEN_OPTIONS)

    return (
      <div className={styles.App}>
        <Header />
        { locationSearchHasFocus &&
          <div className={styles.searchResultBackdrop} />
        }
        { shouldShowUserLocationMessage &&
          <LoadingSpinner />
        }
        { shouldShowDayPage &&
          <DayPage />
        }
        <DatePicker />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/App.js